import * as MergeActions from './merge.actions';
import * as MergeSelectors from './merge.selectors';
import { mergeReducer } from './merge.reducer';
import { MergeEffects } from './merge.effects';
import { IMergeState } from './merge.state';

export {
  MergeActions,
  MergeSelectors,
  mergeReducer,
  MergeEffects,
  IMergeState
};
